(function () {
  function initPDP(root) {
    if (!root || root.dataset.pdpInit) return;
    root.dataset.pdpInit = '1';

    var qs = function (s, c) { return (c || root).querySelector(s); };
    var qsa = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

    var variants = [];
    var config = {};
    try { variants = JSON.parse(qs('[data-pdp-variants]').textContent); } catch (e) {}
    try { config = JSON.parse(qs('[data-pdp-config]').textContent); } catch (e) {}

    /* ---------- Galerie ---------- */
    var slides = qsa('[data-pdp-slide]');
    var thumbs = qsa('[data-pdp-thumb]');
    var counter = qs('[data-pdp-counter-current]');
    var current = 0;

    function setSlide(i) {
      if (!slides.length) return;
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      current = i;
      slides.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === i);
        var v = s.querySelector('video');
        if (v && idx !== i && !v.paused) v.pause();
      });
      thumbs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (counter) counter.textContent = i + 1;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setSlide(parseInt(t.dataset.pdpThumb, 10)); });
    });
    var prev = qs('[data-pdp-prev]');
    var next = qs('[data-pdp-next]');
    if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
    if (next) next.addEventListener('click', function () { setSlide(current + 1); });

    var stage = qs('[data-pdp-stage]');
    if (stage && slides.length > 1) {
      var startX = 0, startY = 0, swiping = false;
      stage.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0];
        startX = t.clientX; startY = t.clientY; swiping = true;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!swiping) return;
        swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) setSlide(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(current + 1); }
      });
    }

    /* ---------- Quantite ---------- */
    var qtyInput = qs('[data-pdp-qty-input]');
    var minus = qs('[data-pdp-qty-minus]');
    var plus = qs('[data-pdp-qty-plus]');
    if (minus && qtyInput) minus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, v - 1);
    });
    if (plus && qtyInput) plus.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = v + 1;
    });

    /* ---------- Variantes ---------- */
    var idInput = qs('[data-pdp-id]');
    var priceEl = qs('[data-pdp-price]');
    var compareEl = qs('[data-pdp-compare]');
    var saveEl = qs('[data-pdp-save]');
    var atcBtn = qs('[data-pdp-atc]');
    var atcText = qs('[data-pdp-atc-text]');
    var buyBtn = qs('[data-pdp-buy]');
    var stickyPrice = qs('[data-pdp-sticky-price]');
    var stickyAtc = qs('[data-pdp-sticky-atc]');

    function selectedOptions() {
      var opts = [];
      qsa('.pdp-option').forEach(function (o) {
        var checked = o.querySelector('.pdp-swatch__input:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.length === opts.length && v.options.every(function (val, i) { return val === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var opts = selectedOptions();
      if (!opts.length) return;
      var v = findVariant(opts);
      qsa('[data-pdp-option-selected]').forEach(function (el, i) { if (opts[i] != null) el.textContent = opts[i]; });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (stickyPrice) stickyPrice.innerHTML = v.price;
      if (compareEl) { compareEl.hidden = !v.has_compare; if (v.has_compare) compareEl.innerHTML = v.compare_at; }
      if (saveEl) { saveEl.hidden = !v.has_compare; if (v.has_compare) saveEl.textContent = '-' + v.save_pct + '%'; }
      [atcBtn, buyBtn, stickyAtc].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (atcText) atcText.textContent = v.available ? config.atcText : config.soldOutText;
      if (stickyAtc) stickyAtc.textContent = v.available ? config.stickyText : config.soldOutText;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    qsa('.pdp-swatch__input').forEach(function (i) { i.addEventListener('change', updateVariant); });

    /* ---------- Ajout au panier ---------- */
    var form = qs('form.pdp-form');
    var busy = false;

    function postCart() {
      return fetch(config.addUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }

    function addToCart(e) {
      if (config.cartBehavior === 'page') return;
      e.preventDefault();
      if (busy || !form) return;
      busy = true;
      if (atcBtn) atcBtn.disabled = true;
      postCart().then(function (res) {
        busy = false;
        if (atcBtn) atcBtn.disabled = false;
        if (!res.ok) { window.location = config.cartUrl; return; }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: res.body } }));
        if (atcBtn) {
          atcBtn.classList.add('is-added');
          if (atcText) atcText.textContent = config.addedText;
          setTimeout(function () {
            atcBtn.classList.remove('is-added');
            if (atcText) atcText.textContent = config.atcText;
          }, 2200);
        }
      }).catch(function () {
        busy = false;
        if (atcBtn) atcBtn.disabled = false;
        window.location = config.cartUrl;
      });
    }
    if (form) form.addEventListener('submit', addToCart);

    /* ---------- Acheter maintenant : panier puis checkout ---------- */
    if (buyBtn && form) {
      buyBtn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        buyBtn.disabled = true;
        postCart().then(function (res) {
          if (!res.ok) { busy = false; buyBtn.disabled = false; return; }
          window.location = config.checkoutUrl;
        }).catch(function () {
          busy = false;
          buyBtn.disabled = false;
          window.location = config.cartUrl;
        });
      });
    }

    /* ---------- Barre sticky mobile ----------
       Elle ne doit jamais recouvrir la barre de navigation mobile
       du theme (.m-mobile-sticky-bar). On mesure sa hauteur reelle
       et on empile la notre juste au-dessus. */
    var sticky = qs('[data-pdp-sticky]');

    function syncStickyOffset() {
      if (!sticky) return;
      var themeBar = document.querySelector('.m-mobile-sticky-bar');
      if (themeBar && themeBar.offsetParent !== null && themeBar.offsetHeight > 0) {
        sticky.style.setProperty('--pdp-sticky-offset', themeBar.offsetHeight + 'px');
        sticky.style.setProperty('--pdp-sticky-safe', '0px');
      } else {
        sticky.style.removeProperty('--pdp-sticky-offset');
        sticky.style.removeProperty('--pdp-sticky-safe');
      }
    }

    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      syncStickyOffset();
      window.addEventListener('resize', syncStickyOffset);
      window.addEventListener('orientationchange', syncStickyOffset);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (passed) syncStickyOffset();
          sticky.classList.toggle('is-visible', passed);
        });
      }, { rootMargin: '0px 0px -60px 0px', threshold: 0 });
      io.observe(atcBtn);
    }
    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atcBtn.click();
      });
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-pdp]'), initPDP); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { initPDP(e.target.querySelector('[data-pdp]') || e.target); });
})();
